import { BigHeading } from "@components/SiteShell"
import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import * as m from "@paraglide/messages"
import type { ContactPageData } from "@site-types/publicPageData"
import type { SupportedLocale as Lang } from "@site-types/site"
import { getLocalizedCareers } from "@utils/siteData"
import { lazy, Suspense } from "react"

const Contact = lazy(() => import("@components/Contact/SendMail"))

export function ContactPage({
  data,
  locale,
  selectedPosition = "",
  isSubPage = false,
}: {
  data: ContactPageData
  locale: Lang
  selectedPosition?: string
  isSubPage?: boolean
}) {
  const careers = getLocalizedCareers(data, locale)
  const careerList = careers.map((career) => career.title ?? "").filter(Boolean)
  return (
    <>
      <BigHeading>
        {(m.contact_heading_label({}, { locale: locale }) || "Contact Us").toUpperCase()}
      </BigHeading>
      <div className={`container contact-form${isSubPage ? "contact-form-template" : ""}`}>
        <h1 className="contact-form-title">
          {m.contact_form_heading({}, { locale: locale }) || "Contact Us"}
        </h1>
        <div className="contact-form-description">
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizeRichHtml(m.contact_form_description({}, { locale: locale })),
            }}
          />
        </div>
        <div className="contact-fields">
          <Suspense
            fallback={
              <div
                className="contact-fields__fallback"
                aria-hidden="true"
              />
            }
          >
            <Contact
              careerList={careerList}
              lang={locale}
              selectedPosition={selectedPosition}
              selectedType={
                selectedPosition
                  ? m.contact_formType_options_recruitment({}, { locale: locale }) || "Recruitment"
                  : m.contact_formType_options_generalEnquiry({}, { locale: locale }) || "General Enquiry"
              }
            />
          </Suspense>
        </div>
      </div>
    </>
  )
}
